import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, AppState } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

import { Small } from '../../../../../../src/components/common/text';

import styles from './app-idle.styles';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import Button from '../../../../../../src/components/common/button';

export class PlainAppIdle extends PureComponent {
  static propTypes = {
    testID: PropTypes.string,
    debug: PropTypes.bool,
  };

  static defaultProps = {
    debug: false,
  };

  constructor() {
    super();

    this.handleAppStateChange = this.handleAppStateChange.bind(this);
    this.logoutStopTimers = this.logoutStopTimers.bind(this);
    this.resetInactiveTimeout = this.resetInactiveTimeout.bind(this);

    this.state = {
      countdownStarted: false,
      appState: AppState.currentState,
      timerId: undefined,
      toBackgroundTime: null
    };
  }

  componentDidMount() {
    AppState.addEventListener('change', this.handleAppStateChange);

    if (this.props.activeTimeoutSeconds >= 0) {
      this.props.inactive.startTimer();
    }
  }

  componentWillUnmount() {
    AppState.removeEventListener('change', this.handleAppStateChange);
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.inactive.resetTimerEvent !== nextProps.inactive.resetTimerEvent) ||
        (this.props.trade.route.path !== nextProps.trade.route.path)) {
      this.resetInactiveTimeout();
    }

    if (this.props.inactive.autoLogoutEvent !== nextProps.inactive.autoLogoutEvent) {
      this.logoutStopTimers();
    }

    if (this.props.inactive.pathChangedEvent !== nextProps.inactive.pathChangedEvent) {
      this.props.inactive.onPathChangedEvent();
    }

    if(this.props.inactive.timeout === this.props.activeTimeoutSeconds - 2){
      this.props.setDatePickerClose(true);
    }
  }

  handleAppStateChange(appState) {
    const { backgroundTimeoutSeconds } = this.props;
    const { toBackgroundTime } = this.state;

    this.setState({ appState });

    if (backgroundTimeoutSeconds >= 0) {
      if (appState === 'background') {
        this.setState({ toBackgroundTime : new Date()});
        const timerId = setTimeout(() => {
          this.logoutStopTimers();
        }, backgroundTimeoutSeconds * 1000);

        this.setState({ timerId });

      } else if (appState === 'active') {
        if(toBackgroundTime){
          const diffInSec = Math.floor((new Date() - toBackgroundTime) / 1000)
          if(diffInSec > backgroundTimeoutSeconds){
            this.setState({ toBackgroundTime: null });
            this.logoutStopTimers();
          } else {
            clearTimeout(this.state.timerId);
          }
        } else {
        clearTimeout(this.state.timerId);
        }
      }
    }
  }

  resetInactiveTimeout() {

    const { inactive } = this.props;
    inactive.resetTimer();
    inactive.stopCountdownTimer();
    this.props.setDatePickerClose(false);
   // this.setState({ countdownStarted: false });
  }

  logoutStopTimers() {

    const { inactive, logout, rmLogout} = this.props;
    inactive.stopCountdownTimer();
    if(this.props.rmAccess.rmAuthorised){
      rmLogout();
    }else{
      logout();
    }
  }

  render() {
    const { debug, inactive, activeTimeoutSeconds, i18n: { messages } } = this.props;
    const { appState } = this.state;

    if (inactive.timeout >= activeTimeoutSeconds) {

      if (this.state.countdownStarted == false) {
        inactive.startCountdownTimer();
        this.setState({ countdownStarted: true });
      }


      if (appState === 'active') {
        // inactive.startCountdownTimer();

        // if (confirm(
        //   'Would you like to remain logged in? ' +
        //   `If you do nothing, this app will log you out safely in ${inactive.countdown} seconds`
        // )) {
        //   this.resetInactiveTimeout();
        // } else {
        //   this.logoutStopTimers();
        // }

        return (

          <BlurModal
            visible
            doneVisible={false}
            title={"Deutsche Wealth Online"}
            onDone={() => this.resetInactiveTimeout()}
          >

            <div className="timeout-modal">
              <div className="row">
                <div className="small-12 text-center">
                  <div className="callout">

                    <h2>{messages['app.common.appIdle.remailLogged']}</h2>
                    <div>{messages['app.common.appIdle.logoutMsg']} {inactive.countdown} {messages['app.common.appIdle.seconds']}</div>


                    <div className="row">
                      <div className="column small-push-3 small-6 pad-top-20">

                        <div className="row">
                          <div className="column small-6" style={{color: '#fff', lineHeight: 2 }} >
                            <Button id="resetInactiveTimeout" title={messages['app.common.alert.yes']} size="normal" onClick={this.resetInactiveTimeout} />
                          </div>

                          <div className="column small-6" style={{color: '#fff', lineHeight: 2 }} >
                            <Button id="logoutStopTimers" title={messages['app.common.alert.no']} size="normal" onClick={this.logoutStopTimers} />
                          </div>

                        </div>


                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </BlurModal>

        )


      }
        this.logoutStopTimers();

    }

    if (debug) {
      return (
        <View style={styles.root}>
          <Small style={styles.text}>{messages['app.common.appIdle.inactiveSeconds']} {inactive.timeout}; {messages['app.common.appIdle.state']}: {appState}</Small>
        </View>
      );
    }

    return null;
  }
}

export default createContainer({
  $queries: {
    logout: { $call: 'auth.logout' },
    rmLogout: { $call : 'rmAccess.logout'},
    rmAccess:{
      rmAuthorised: true
    },
    inactive: {
      timeout: true,
      countdown: true,
      startTimer: { $call: 'startTimer' },
      resetTimer: { $call: 'resetTimer' },
      resetTimerEvent: true,
      startCountdownTimer: { $call: 'startCountdownTimer' },
      stopCountdownTimer: { $call: 'stopCountdownTimer' },
      autoLogoutEvent: true,
      pathChangedEvent: true,
      onPathChangedEvent: { $call: 'onPathChangedEventForCh' },
    },
    trade: {
      route: {
        path: true
      }
    },
    i18n: {
      messages: true,
    },
    ui: {
      inactive: {
        activeTimeoutSeconds: true,
        backgroundTimeoutSeconds: true,
      },
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    }
  },
}, ({ ui, ...queries }) => ({
  activeTimeoutSeconds: ui.inactive.activeTimeoutSeconds,
  backgroundTimeoutSeconds: ui.inactive.backgroundTimeoutSeconds,
  ...queries
}))(PlainAppIdle);
